<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-sm-10 col-lg-9">
					<h1><i class="far fa-user-circle m-r-sm"></i> Account Details</h1>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-2" v-if="user.isClientOrCarrier">
          <p class="job-status-header text-warning" v-if="user.isNotActivated">Inactive</p>
          <p class="job-status-header text-warning" v-else-if="user.isArchived">Archived</p>
          <p class="job-status-header text-danger" v-else-if="user.isDisabled">Disabled</p>
          <p class="job-status-header text-info" v-else-if="user.isUnverified">Unverified</p>
          <p class="job-status-header text-success" v-else-if="user.isEnabled">Enabled</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: mapGetters('user', ['user'])
  }
</script>



// WEBPACK FOOTER //
// SettingsHeading.vue?54589032